import React from 'react';

export default function BatchAssignment({ enabled, onToggle }) {
  return (
    <div style={{
      padding: '12px 16px',
      background: 'rgba(139, 69, 19, 0.05)',
      border: '1px solid rgba(139, 69, 19, 0.2)',
      borderRadius: '8px',
      marginBottom: '16px'
    }}>
      <label style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        cursor: 'pointer'
      }}>
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onToggle(e.target.checked)}
          style={{
            width: '18px',
            height: '18px',
            cursor: 'pointer'
          }}
        />
        
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#2b2b2b',
            marginBottom: '2px'
          }}>
            Batch Assignment Mode
          </div>
          
          <div style={{
            fontSize: '12px',
            color: '#666'
          }}>
            Schedule multiple jobs in sequence automatically
          </div>
        </div>
      </label>

      {enabled && (
        <div style={{
          marginTop: '12px',
          padding: '10px',
          background: 'white',
          borderRadius: '6px',
          fontSize: '12px',
          color: '#666'
        }}>
          <div style={{ marginBottom: '6px' }}>
            ℹ️ <strong>How it works:</strong>
          </div>
          <ul style={{
            margin: '0',
            paddingLeft: '20px'
          }}>
            <li>Select multiple jobs from the list</li>
            <li>Jobs will be scheduled consecutively</li>
            <li>Start date applies to first job</li>
            <li>Weekends and holidays are automatically skipped</li>
            <li>Crew assignment applies to all selected jobs</li>
          </ul>
        </div>
      )}
    </div>
  );
}